import type { RibbonControlGroupDefinitionMLR, RibbonTabDefinitionBase } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { constructKeytip, Multiline } from 'owa-command-ribbon';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import { getUniqueTabId } from 'owa-mail-ribbon-utils/lib/getUniqueTabId';
import { type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { getMLRTabGroups } from '../../../util/getTabGroups';
import { getMLRSearchToolsTabControlDefinition } from './getMLRSearchToolsTabControlDefinition';
import { getMLRSearchToolsTabGroupLayouts } from './getMLRSearchToolsTabGroupLayouts';
import { getMLRSearchToolsTabCommonGroupFlyout } from './getMLRSearchToolsTabCommonGroupFlyout';
import { getMailRibbonConfigStore } from 'owa-mail-ribbon-store/lib/store/store';
import { search_tools_tab } from '../../../ribbon_search_tab.locstring.json';
import loc from 'owa-localize';

const getMLRSearchToolsTab: (props: ReadOnlyRibbonControlDefProps) => RibbonTabDefinitionBase =
    owaComputedFn(function getMLRSearchToolsTab(
        props: ReadOnlyRibbonControlDefProps
    ): RibbonTabDefinitionBase {
        return {
            type: Multiline,
            id: getUniqueTabId(14, undefined /* editorId */, props.itemId, props.isPopout),
            title: loc(search_tools_tab),
            controlGroups: { type: Multiline, groups: getSearchToolsTabGroups(props) },
            initialScalingSteps: [],
            scalingSteps: [],
            keytipProps: constructKeytip([], 14, true /* hasMenu */),
        };
    });
export default getMLRSearchToolsTab;

/**
 * Retrieves the groups within the Search Tools tab, as well as the actions that
 * fall under each group.
 * @returns an object that contains the sub-groups and corresponding actions of the
 * Search Tools tab
 */
const getSearchToolsTabGroups = owaComputedFn(function getSearchToolsTabGroups(
    props: ReadOnlyRibbonControlDefProps
): RibbonControlGroupDefinitionMLR[] {
    const ribbonConfig = getMailRibbonConfigStore(props.mailboxInfo);
    const searchToolsTabConfig = ribbonConfig?.multiline?.searchToolsTab;
    let searchToolsTabGroups: RibbonControlGroupDefinitionMLR[] = new Array();
    searchToolsTabGroups = getMLRTabGroups(
        14,
        searchToolsTabConfig.layout,
        getMLRSearchToolsTabControlDefinition,
        getMLRSearchToolsTabGroupLayouts,
        getMLRSearchToolsTabCommonGroupFlyout,
        props
    );
    return searchToolsTabGroups;
});
